import React from 'react';
import { Phone, MapPin, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PHONE, PHONE_TEL, GOOGLE_MAPS_URL } from '../constants/business';
export function PlanYourVisitCTA() {
  return <section className="py-20 bg-brand-hunter text-brand-offwhite" data-id="element-135">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-136">
        <h2 className="text-3xl md:text-4xl font-serif mb-6" data-id="element-137">
          Plan Your Visit to Kjergaard Sports
        </h2>
        <p className="text-lg text-brand-offwhite/80 mb-10 leading-relaxed" data-id="element-138">
          Call ahead with questions or make the drive to Lake Benton, Minnesota
          to browse the in-store selection.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-139">
          <a href={PHONE_TEL} className="bg-brand-leather hover:bg-brand-wood text-brand-offwhite px-8 py-4 rounded-sm font-medium transition-colors flex items-center justify-center" data-id="element-140">
            <Phone className="w-5 h-5 mr-2" data-id="element-141" />
            Call {PHONE}
          </a>
          <a href={GOOGLE_MAPS_URL} target="_blank" rel="noopener noreferrer" className="border-2 border-brand-bone hover:border-brand-leather hover:bg-brand-leather/10 text-brand-offwhite px-8 py-4 rounded-sm font-medium transition-colors flex items-center justify-center" data-id="element-142">
            <MapPin className="w-5 h-5 mr-2" data-id="element-143" />
            Get Directions
          </a>
          <Link to="/contact" className="bg-brand-offwhite/10 hover:bg-brand-offwhite/20 text-brand-offwhite px-8 py-4 rounded-sm font-medium transition-colors flex items-center justify-center backdrop-blur-sm" data-id="element-144">
            <Mail className="w-5 h-5 mr-2" data-id="element-145" />
            Contact Us
          </Link>
        </div>
      </div>
    </section>;
}